import classNames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '../lang';
import { Color, Font, Margin } from './classNames';

export default function FeePaymentDisclaimer({ className }) {
	return (
		<div className={classNames(Font.footnote, Color.fillPrimary, Margin.HMedium, className ?? '')}>
			{t(
				'Estimated blockchain fee maximum. You are only charged the actual network fee at the moment of confirmation.'
			)}
		</div>
	);
}

FeePaymentDisclaimer.propTypes = {
	className: PropTypes.string,
};
